module.exports = __webpack_public_path__ + "static/media/error-something-went-wrong.ac4ee9d7.svg";